import { FC } from 'react';
import { Box, Tooltip } from '@mui/material';
import CreateOutlinedIcon from '@mui/icons-material/CreateOutlined';
import { copy, minifyHtml } from 'helpers/functions';
import { useTranslation } from 'react-i18next';
import { ActionsType } from '../../types';
import { ShareButton } from '../ShareButton';

const Actions: FC<ActionsType> = ({ isGeneratingForThis, defaultValue, title, onEditMode }) => {
    const { t } = useTranslation();
    // const [isOpenFeedbackModal, setIsOpenFeedbackModal] = useState<boolean>(false);

    // const onDislike = () => {
    //     if (isLiked !== false) {
    //         onOpenFeedbackModal();
    //     }
    //     onToggleLike(false);
    // };

    // const onToggleLike = (value: boolean) => {
    //     const updatedMessages = messages?.map((item) => {
    //         if (item.message_id === messageId) {
    //             return { ...item, isLiked: isLiked === value ? null : value };
    //         }
    //         return item;
    //     });
    //     onUpdateDoc(CONVERSATIONS, document_id, { messages: updatedMessages });
    // };

    const onCopy = () => {
        copy({ value: minifyHtml(defaultValue), noMessage: true });
    };

    // const onOpenFeedbackModal = () => setIsOpenFeedbackModal(true);
    // const onCloseFeedbackModal = () => setIsOpenFeedbackModal(false);

    return (
        <>
            <Box className="all-actions">
                <Box className="actions">
                    <Box className="feedback">
                        {/* <Tooltip placement="top" title={t('web_app.tooltips.like_btn')}>
                            <span>
                                <button
                                    className={isLiked ? 'active-button' : ''}
                                    onClick={() => onToggleLike(true)}
                                    disabled={isGeneratingForThis}
                                >
                                    <ThumbUpOffAltIcon />
                                </button>
                            </span>
                        </Tooltip>
                        <Tooltip placement="top" title={t('web_app.tooltips.dislike_btn')}>
                            <span>
                                <button
                                    className={isLiked === false ? 'active-button' : ''}
                                    onClick={() => onDislike()}
                                    disabled={isGeneratingForThis}
                                >
                                    <ThumbDownOffAltIcon />
                                </button>
                            </span>
                        </Tooltip> */}
                    </Box>
                    <Box>
                        <ShareButton title={title} content={defaultValue} />
                    </Box>
                </Box>
                <Box sx={{ width: 210 }}>
                    <Tooltip placement="bottom" title={t('web_app.tooltips.edit_btn')}>
                        <span>
                            <button
                                className="edit-btn"
                                onClick={onEditMode}
                                disabled={isGeneratingForThis}
                            >
                                <CreateOutlinedIcon /> {t('web_app.home.output.edit_btn')}
                            </button>
                        </span>
                    </Tooltip>
                </Box>
            </Box>
            {/* <FeedbackModal
                messageId={messageId}
                messages={messages}
                document_id={document_id}
                open={isOpenFeedbackModal}
                onClose={onCloseFeedbackModal}
            /> */}
        </>
    );
};

export default Actions;
